import { render, staticRenderFns } from "./InputI18n.vue?vue&type=template&id=4db5d67e"
import script from "./InputI18n.vue?vue&type=script&lang=js"
export * from "./InputI18n.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports